import Component from '../inherited/Component'
import axios from 'axios'

export default class AjaxReplace extends Component {
    constructor (elem, theme, options, ctx) {
      super(elem, theme, options, ctx)
      this._checkoutForms = document.querySelectorAll(`form[action="${window.routes.cart_url}"]`)
    }

    async mount () {
        for(let form of this._checkoutForms) {
            form.addEventListener('submit', (e) => {
                let redirectUrl = ''
                if(form.querySelector('[name="redirect_url"]')) {
                    redirectUrl =  form.querySelector('[name="redirect_url"]').value
                } else if(document.querySelector('[name="redirect_url"]')) {
                    redirectUrl =  document.querySelector('[name="redirect_url"]').value
                }
                if(redirectUrl != '') {
                    e.preventDefault()
                    window.location.href = redirectUrl
                }
            })
        }
    }
}